import { HttpClient } from '@angular/common/http';
import {
  Component,
  Output,
  EventEmitter,
  Input,

  OnInit,
  HostListener,
  ElementRef,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { NavigationEnd, Router } from '@angular/router';
import { ChangePasswordModalComponent } from 'src/app/pages/ui-components/change-password-modal/change-password-modal.component';
import { apiData } from 'src/app/services/api-lookup';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { SearchService } from 'src/app/services/search.service';
import { SharedFundDataService } from 'src/app/services/shared-fund-data.service';
import { readEncodedSession, readSessionUserId } from 'src/app/services/session-storage.util';
import { firstNonNullish, orBlank } from 'src/app/services/value.util';
const SharedServiceCalling_get = apiData[177].SharedServiceCalling_get;
const SharedServiceSeen_Get = apiData[178].SharedServiceSeen_Get;
const SharedServiceSeenALL_Get = apiData[179].SharedServiceSeenALL_Get;
const GlobalSearch_Get = apiData[200].GlobalSearch_Get;
const WorkFlow_Get = apiData[61].WorkFlow_Get;
const LogoutDevice = apiData[327].LogoutDevice;
const LogoutAllDevice = apiData[328].LogoutAllDevice;

export interface NotificationDto {
  investorAccountId: number;
  fundId: number;
  type: string;
  title: string;
  message: string;
  investorId: number;
  iM_Id: number;
  metadata: string;
  deliveryChannels: string;
  seen: boolean;
  seenAt: string | null;
  createdAt: string;
}
export interface Page {
  Customer: null;
  id: number;
  name: string;
  category: 'Investors' | 'Funds' | 'Documents';
  url: string;
  totalCount: number;
}
const LogoForUser_Get=apiData[176].LogoForUser_Get;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  
})
export class HeaderComponent implements OnInit  {
  isSmallScreen: boolean = false;
  currentDate: Date = new Date();
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  groupedResults: any[] = [];
  selectedPage: any = null;
    avatar: any;
  searchQuery: string = '';
  
  FirstName:string;
  MiddleName:string;
  LastName:string;
  UserType:string;
 
  
  dropdownOpen = false;
  unreadCount = 0;
  isLoading = true;
  investorId: number = 0;
  notifications: any[] = [];


  showFiller = false;
  itemSelected: any;
  members: any;
  Admin: any;
  itemSelectednotificationsid: any;


  showFilters: boolean;
  searchInputRef: any;
  isHeaderLoading: boolean;
  Username: any;



constructor(
  public dialog: MatDialog,
  private searchService: SearchService,
  private router: Router,
  private eRef: ElementRef,
  private http: HttpClient,
  private apiService: ApiService,
  private sharedFundDataService: SharedFundDataService,
  private authorizationService: AuthorizationService,
  private authService: AuthService
) {
  this.checkScreenSize();

   this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      this.clearSearchField();
    }
  });
}

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }




  formatMessage(message: string, maxWords: number): string {
    if (!message) return '';
    const words = message.split(' ');
    return words.length > maxWords
      ? words.slice(0, maxWords).join(' ') + '...'
      : message;
  }
  checkScreenSize() {
    this.isSmallScreen = window.innerWidth <= 768;
  }

selectedCategory = 'All';

categories = ['All', 'Investors', 'Funds', 'Documents'];

filteredPages: Page[] = [];

clearSearchField(): void {
  this.searchQuery = '';
  this.showFilters = false;
  this.filteredPages = [];
  this.groupedResults = [];
  this.selectedPage = null;
}
showSearchModal = false;
  showModal: boolean = false; 



searchOpen = false;
openDropdown() {
  this.dropdownOpen = true;
  this.showFilters = true;
}

closeDropdown() {
  this.dropdownOpen = false;
  this.showFilters = false;
}

closeDropdownOnBackdrop(e: MouseEvent) {
  this.closeDropdown();
}

onSearchFocus() {
  this.showFilters = true;
   this.showModal = true; 
  this.selectedPage = null; 
   this.searchOpen = true;
}

onSearchInput() {
  if (this.selectedPage) this.selectedPage = null;

  if (this.searchQuery.trim() === '') {
    this.filteredPages = [];
    this.groupedResults = [];
    return;
  }

  if (this.UserType === 'Customer') {
    this.filteredPages = [];
    this.groupedResults = [];
    return;
  }

  this.GlobalSearch();
}


onCategoryClick(category: string) {

  const categoryPermissions: Record<string, string> = {
    Investors: 'Investor',
    Funds: 'Scheme',
    Documents: 'DocTemplate'
  };

  // All is always allowed
  if (category !== 'All') {

    const permissionKey = categoryPermissions[category];

    // Permission check after clicking category
    if (permissionKey && !this.authorizationService.canView(permissionKey)) {

      this.selectedCategory = 'All';
      this.filteredPages = [];
      this.groupedResults = [];

      return;
    }
  }

  this.selectedCategory = category;

  if (this.searchQuery.trim()) {
    this.GlobalSearch();
    this.showModal = true;
  }
}

GlobalSearch(): void {
  this.isLoading = true;

  const apiUrl = `${GlobalSearch_Get}`;
    
const data = readEncodedSession('Adviser');
          const AdviserId = Number(data.masterId);
   
          const AdviserIds = Number(data.iM_Id);
            const decodedStaff = readEncodedSession('Staff');
            const StaffId = Number(decodedStaff.staffId);
  const requestBody = {
    searchName: this.searchQuery,
    searchCategory: this.selectedCategory === 'All' ? '' : this.selectedCategory,
    imid:AdviserIds,
    gimm_MasterId:AdviserId,
    staffId:StaffId,
    p_UserId: Number(readSessionUserId())
  };

  this.apiService.httpPost(apiUrl, requestBody).subscribe({
    next: (response: any) => this.handleGlobalSearchSuccess(response),
    error: (err) => {
      console.error('❌ Error during search:', err);
      this.isLoading = false;
    }
  });
}

﻿private handleGlobalSearchSuccess(response: any): void {
  const data = this.extractSearchData(response);

  if (data.length > 0) {
    this.filteredPages = data.map((item: any): Page => this.mapSearchItemToPage(item));
    this.groupedResults = this.groupSearchResults();
  } else {
    this.filteredPages = [];
    this.groupedResults = [];
  }

  this.isLoading = false;
}

private extractSearchData(response: any): any[] {
  if (Array.isArray(response)) return response;
  if (response?.data && Array.isArray(response.data)) return response.data;
  if (response?.data && typeof response.data === 'object') {
    return [
      ...(response.data.investors || []),
      ...(response.data.funds || []),
      ...(response.data.documents || [])
    ];
  }
  return [];
}

private mapSearchItemToPage(item: any): Page {
  const rawCategory = (item.category || item.Category || 'Investors').toString().trim();
  const category = (['Investors', 'Funds', 'Documents'].includes(rawCategory)
    ? rawCategory
    : 'Investors') as 'Investors' | 'Funds' | 'Documents';

  let url = '/';
  if (category === 'Investors') url = '/ui-components/ProfileDashboard';
  else if (category === 'Funds') url = '/ui-components/SchemeDashboard';
  else if (category === 'Documents') url = '/ui-components/Standarddocument';

  return {
    id: firstNonNullish(item.id, item.Id, 0),
    name: firstNonNullish(item.name, item.Name, 'Untitled'),
    category,
    url,
    totalCount: firstNonNullish(item.totalCount, 0),
    Customer: null,
  };
}

private groupSearchResults() {
  const categoryPermissions: Record<string, string> = {
    Investors: 'Investor',
    Funds: 'Scheme',
    Documents: 'DocTemplate'
  };

  let categoriesToShow: string[];
  if (this.selectedCategory === 'All') {
    categoriesToShow = (['Investors', 'Funds', 'Documents'] as const)
      .filter(category =>
        this.authorizationService.canView(categoryPermissions[category])
      );
  } else if (this.authorizationService.canView(categoryPermissions[this.selectedCategory])) {
    categoriesToShow = [this.selectedCategory];
  } else {
    categoriesToShow = [];
  }

  return categoriesToShow
    .map(c => ({
      category: c,
      items: this.filteredPages.filter(p => p.category === c)
    }))
    .filter(g => g.items.length > 0);
}


onResultClick(page: Page) {
  if (!page) return;

  this.searchQuery = page.name ?? '';

  this.showFilters = false;
  this.selectedPage = page;



  if (page.category === 'Funds') {
      sessionStorage.removeItem('FundId');
  sessionStorage.removeItem('Insertdata');
  sessionStorage.removeItem('FundName');
    sessionStorage.setItem('Insertdata', '0');
    sessionStorage.setItem('FundId', page.id ? String(page.id) : '');
    sessionStorage.setItem('FundName', page.name ?? '');
    this.router.navigate(['/ui-components/SchemeDashboard']);
   
  } 
  
  else if (page.category === 'Investors') {
    this.OpentheDashboard(page); 
  } 
  else if (page.category === 'Documents') {
    this.router.navigate(['/ui-components/Standarddocument']);
      
  }

  this.filteredPages = [];
  this.groupedResults = [];
   this.showModal = true; 
}
isMatch(page: Page): boolean {
  if (!this.searchQuery) return false;
  return page.name.toLowerCase().includes(this.searchQuery.toLowerCase());
}


 clearDashboardSession(): void {
    this.resetFundData();
    sessionStorage.removeItem('dashboardOpened');
    sessionStorage.removeItem('dashboardInvestment');
    sessionStorage.removeItem('InvestorData');
    sessionStorage.removeItem('customerType');
     sessionStorage.removeItem('hasNavigated');
     sessionStorage.removeItem('AccountID');
        sessionStorage.removeItem('expandedFundIndex');
     sessionStorage.removeItem('Holdingtype');
     sessionStorage.removeItem('Folioworkflow');
      sessionStorage.removeItem('FundName')
       sessionStorage.removeItem('FundID')
           sessionStorage.removeItem('ProfileName')
    sessionStorage.setItem('dashboardInvestment', '0');
    
  }
  resetFundData() {
  this.sharedFundDataService.clearFundList();
}
 OpentheDashboard(investor: any) {
  this.resetFundData();
  sessionStorage.removeItem('dashboardInvestment');
  sessionStorage.removeItem('InvestorData');
  sessionStorage.removeItem('customerType');
  sessionStorage.removeItem('hasNavigated');
     sessionStorage.removeItem('AccountID');
      sessionStorage.removeItem('expandedFundIndex');
     sessionStorage.removeItem('Holdingtype');
     sessionStorage.removeItem('Folioworkflow');
      sessionStorage.removeItem('FundName')
          sessionStorage.removeItem('FundID')
           sessionStorage.removeItem('ProfileName')
  sessionStorage.setItem('dashboardOpened', '1');

  const data = readEncodedSession('Adviser');
  const AdviserId = Number(data.masterId);

  const requestBody = {
    entityID: investor.id,
    accountID: 0,
    masterId: AdviserId
  };

  const apiUrl = `${WorkFlow_Get}`;

  this.fetchWorkflowIds(apiUrl, requestBody, (allStatusIds: number[]) => {
    const selectedData = {
      investorId: investor.id,
      accountId: 0,
      holdingtype:'',
      workflowId: allStatusIds
    };

    sessionStorage.setItem('customerType', JSON.stringify(investor.Customer));

    const base64 = btoa(JSON.stringify(selectedData));
    sessionStorage.setItem('InvestorData', JSON.stringify(base64));

    this.router.navigate(['/ui-components/ProfileDashboard']);
  });
}


fetchWorkflowIds(apiUrl: string, requestBody: any, callback: (ids: number[]) => void) {
  this.apiService.httpPost(apiUrl, requestBody).subscribe({
    next: (response: any[]) => {
      if (Array.isArray(response)) {
        const allStatusIds = response.map(item => item.imweS_StatusID);
        callback(allStatusIds);
      } else {
        console.warn('Invalid response');
        callback([]);
      }
    },
    error: (err) => {
      console.error('Error fetching workflow IDs:', err);
      callback([]);
    }
  });
}

  getCount(category: string): number {
    if (category === 'All') return this.filteredPages.length;
    return this.filteredPages.filter(p => p.category === category).length;
}


  closeSearch() {
    this.showFilters = false;
  }

  resetSearch() {
    this.searchQuery = '';
    this.showFilters = false;
    this.filteredPages = [];
    this.groupedResults = [];
  }

 













 
  navigateToPage(url: string): void {
    this.router.navigateByUrl(url);
    this.searchQuery = '';
    this.filteredPages = [];
  }
 


 
 @HostListener('document:click', ['$event'])
clickOutside(event: Event) {
  if (!this.eRef.nativeElement.contains(event.target)) {
    this.filteredPages = [];
    this.groupedResults = [];
    this.showFilters = false;      
    this.searchQuery = '';          
  }
  if (this.dropdownOpen && !this.eRef.nativeElement.contains(event.target)) {
    this.dropdownOpen = false;
  }
}

 @HostListener('document:keydown.escape')
onEscapeKey() {
  this.showFilters = false;
  this.searchQuery = '';
  this.filteredPages = [];
  this.groupedResults = [];
}

// ChangePassword(): void {
//   const dialogRef = this.dialog.open(ChangePasswordModalComponent, {
//     width: '560px',
//     maxWidth: '85vw',
//     disableClose: true,
//     autoFocus: false,
//     panelClass: 'change-password-dialog-panel'
//   });
randomId = Math.random().toString(36).substring(2, 8);
ChangePassword(): void {
  this.clearSearchField();

  const dialogRef = this.dialog.open(ChangePasswordModalComponent, {
    width: '560px',
    maxWidth: '85vw',
    disableClose: true,
    autoFocus: false,
    panelClass: 'change-password-dialog-panel'
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result?.success) {
      console.log('Password changed successfully');
    }
  });
}
  // dialogRef.afterClosed().subscribe(result => {
  //   if (result?.success) {
     
  //     console.log('Password changed successfully');
  //   }
  // });
//}

logout() {

  this.authService.logout();

}
  onMemberClick(event: Event) {
    const target = event.target as HTMLSelectElement;
    if (target) {
      const value = target.value;
      this.itemSelected = value;
      sessionStorage.setItem("customerId", this.itemSelected);
      window.location.reload();
    }
  }
  
  
  getMemberData() {
    
     const selectedItemId = sessionStorage.getItem('customerId');
    if (selectedItemId) {
      this.itemSelected = selectedItemId;
    }
    const storedMembers = sessionStorage.getItem('MembersData');
    if (storedMembers) {
      this.members = JSON.parse(storedMembers);
    }
    else {
      this.members = [];
    }
  
   
  
    return this.members;
  }

  ngOnInit() {
    const user = this.getDecodedSession('User');
    this.Username = user?.fullName || user?.email || 'User';
      this.loadSearchCategories();
      this.isHeaderLoading = true;
    const encodedUserType = sessionStorage.getItem('UserType');
if (encodedUserType) {
  this.UserType = JSON.parse(atob(encodedUserType));

}
const data = readEncodedSession('InvestorData');
 if (data?.investorId) {
  this.investorId = Number(data.investorId);
} else {

  this.investorId = 0;

}
    const roleNames = sessionStorage.getItem("GPRoleNames");
   
    if (roleNames) {
      const parsedRoles = JSON.parse(roleNames);
      if (Array.isArray(parsedRoles) && parsedRoles.length > 0) {
        this.Admin = parsedRoles[0];
      }
    }

    
    this.getMemberData();
   if (this.investorId > 0) {
   

    if (this.UserType === 'Customer') {
     this.loadUnreadCount()
    }
  }
    this.isHeaderLoading = false;

    
      
      const userTypeRaw = sessionStorage.getItem('UserType');
      if (!userTypeRaw) {
        this.FirstName = 'Ampsys';
        this.setAvatarFromName(this.Username);
        return;
      }
    
      this.UserType = JSON.parse(atob(userTypeRaw));
    
      if (this.UserType === 'Admin') {
        this.initAdminProfile();
        return;
      }
    
      if (this.UserType === 'Customer') {
        this.initCustomerProfile();
        return;
      }
    
      this.FirstName = 'Ampsys';
      this.setAvatarFromName(this.Username);
    }
    
    private initAdminProfile(): void {
      const adviser = this.getDecodedSession('Adviser');
    
      this.FirstName = adviser?.orgName ?? 'Admin';
    
      this.GetProfileImage().subscribe({
        next: (res: any) => {
          if (res?.fileBase64) {
            this.avatar = res.fileBase64;
          } else {
            this.setAvatarFromName(this.Username);
          }
        },
        error: () => this.setAvatarFromName(this.Username),
      });
    }
 


private loadSearchCategories(): void {
  const allowedCategories: string[] = [];

  if (this.authorizationService.canView('Investor')) {
    allowedCategories.push('Investors');
  }

  if (this.authorizationService.canView('Scheme')) {
    allowedCategories.push('Funds');
  }

  if (this.authorizationService.canView('DocTemplate')) {
    allowedCategories.push('Documents');
  }

  // Show "All" only if at least one category is permitted
  this.categories = allowedCategories.length > 0
    ? ['All', ...allowedCategories]
    : [];
}




    private initCustomerProfile(): void {
      const investor = this.getDecodedSession('InvestorData');
    
      if (!investor) {
        this.FirstName = 'Investor';
        this.setAvatarFromName(this.FirstName);
        return;
      }
    
      this.FirstName = investor.inv_CompanyName
        || [investor.inv_FName, investor.inv_MName, investor.inv_LName]
            .filter(Boolean)
            .join(' ');
    
      this.GetProfileImages().subscribe({
        next: (res: any) => {
          if (res?.fileBase64) {
            this.avatar = res.fileBase64;
          } else {
            this.setAvatarFromName(this.FirstName);
          }
        },
        error: () => this.setAvatarFromName(this.FirstName),
      });
    }
    private getDecodedSession(key: string): any {
      try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        return JSON.parse(atob(JSON.parse(raw)));
      } catch {
        return null;
      }
    }
    
    private setAvatarFromName(name: string): void {
      const initials = this.getInitials(name);
      this.avatar = `https://ui-avatars.com/api/?name=${initials}&background=ffffff&color=4F46E5&size=128&bold=true`;
    }
      getInitials(name: string): string {
  return name
    .split(' ')
    .map(n => n.charAt(0).toUpperCase())
    .join('');
}
GetProfileImage() {
  const data = readEncodedSession('Adviser');
          const iM_Id = Number(data.iM_Id);
  const userId = JSON.parse(atob(sessionStorage.getItem('UserID') ?? 'null'));
  const requestBody = {
    p_Id: iM_Id,
    p_IMU_UserType: "Admin",
    p_userid:Number(userId),
  };

  const apiUrl = `${LogoForUser_Get}`;
  return this.apiService.httpPost(apiUrl, requestBody);
}
GetProfileImages() {
  const data = readEncodedSession('InvestorData');
  const investorIds = Number(data.investorId);
  const userId = JSON.parse(atob(sessionStorage.getItem('UserID') ?? 'null'));
  const requestBody = {
    p_Id: investorIds,
    p_IMU_UserType: "Customer",
    p_userid:Number(userId),
  };

  const apiUrl = `${LogoForUser_Get}`;
  return this.apiService.httpPost(apiUrl, requestBody);
}
  
  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;

    if (this.dropdownOpen) {
      this.loadNotifications();
    }
  }
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

 closeMenu() {
  this.menuTrigger.closeMenu();
}
   

 groupedNotifications: Array<{ category: string; items: any[] }> = [];

categories1: string[] = [ 'Capital Calls', 'Documents' ,'Payment Received', 'Unit Allocation', 'Other'];
categorySelection: any = {
  'All': true,
  'Capital Calls': false,
  'Payment Received': false,
  'Unit Allocation': false,
  'Documents': false,
  'Other': false
};
filteredNotifications: any[] = [];


onCategoryChange(category: string) {
  if (category === 'All') {
    const value = this.categorySelection['All'];

    for (let c of this.categories1) {
      this.categorySelection[c] = value;
    }
  } else {
    if (!this.categorySelection[category]) {
      this.categorySelection['All'] = false;
    }

    const allSelected = this.categories1.every(c => this.categorySelection[c]);
    if (allSelected) {
      this.categorySelection['All'] = true;
    }
  }

  this.applyFilter();
}

applyFilter() {
  if (this.categorySelection['All']) {
    this.filteredNotifications = this.groupedNotifications.flatMap(g => g.items);
    return;
  }

  this.filteredNotifications = this.groupedNotifications
    .filter(g => this.categorySelection[g.category])
    .flatMap(g => g.items);
}
loadNotifications(): void {
  this.isLoading = true;
  const url = `${SharedServiceCalling_get}`;
  const userId = readSessionUserId();
  const body = { inv_InvestorId: userId, p_UserId: Number(userId) };

  this.apiService.httpPost(url, body).subscribe({
    next: (res: any) => this.handleLoadNotificationsSuccess(res),
    error: (err) => {
      console.error('❌ Error loading notifications:', err);
      this.isLoading = false;
    }
  });
}

private handleLoadNotificationsSuccess(res: any): void {
    if (res?.success && Array.isArray(res.data)) {
      this.notifications = res.data;
      this.groupedNotifications = [];

      this.notifications.forEach((n: any) => this.addNotificationToGroup(n));

      this.groupedNotifications.forEach(group => {
        group.items.sort((a, b) => b.date.getTime() - a.date.getTime());
      });

      this.onCategoryChange('All');

    } else {
      console.warn('⚠️ No notifications found.');
    }

    this.isLoading = false;
}

private getNotificationCategory(n: any): string {
  const normalizedType = (orBlank(n.imnpE_EventCode)).replace(/\s+/g, '').toLowerCase();
  const title = (orBlank(n.imnpE_EventCode)).toLowerCase();

  if (normalizedType.includes('capital_call_issued_inapp')) return 'Capital Calls';
  if (normalizedType.includes('payment')) return 'Payment Received';
  if (normalizedType.includes('unit')) return 'Unit Allocation';
  if (normalizedType.includes('document') || title.includes('statement')) return 'Documents';
  return 'Other';
}

private parseRenderedNotification(n: any): { title: string; message: string } {
  let rendered = { title: '', message: '' };
  if (n.imnpE_RenderedNotification) {
    try {
      rendered = JSON.parse(n.imnpE_RenderedNotification);
    } catch (err) {
      console.warn('Error parsing rendered notification JSON', err);
    }
  }
  return rendered;
}

private addNotificationToGroup(n: any): void {
  const rendered = this.parseRenderedNotification(n);

  n.title = (orBlank(n.imnpE_EventCode)).replace(/_INAPP$/i, '');
  n.message = rendered.message;

  const category = this.getNotificationCategory(n);

  const item = {
    initials: (orBlank(n.title?.substring(0, 2))).toUpperCase(),
    name: orBlank(n.title),
    message: orBlank(n.message),
    date: new Date(n.imnpE_InAppSeenAt || n.imnpE_CreatedAt || Date.now()),
    timeAgo: this.timeAgo(n.imnpE_CreatedAt || n.imnpE_InAppSeenAt),
    seen: n.imnpE_InAppStatus,
    notificationsid: n.imnpE_Id,
    fundid: n.fundId
  };

  let group = this.groupedNotifications.find(g => g.category === category);
  if (!group) {
    group = { category, items: [] };
    this.groupedNotifications.push(group);
  }
  group.items.push(item);
}

sortAscending: boolean = true;

toggleSortNotifications() {
  this.sortAscending = !this.sortAscending;

  this.filteredNotifications.sort((a, b) => {
    const dateA = a.date.getTime();
    const dateB = b.date.getTime();
    return this.sortAscending ? dateA - dateB : dateB - dateA;
  });
}





timeAgo(dateString: string): string {
  const date = new Date(dateString);
  const diff = Math.floor((new Date().getTime() - date.getTime()) / 60000);
  if (diff < 1) return 'just now';
  if (diff < 60) return `${diff} minutes ago`;
  if (diff < 1440) return `${Math.floor(diff / 60)} hours ago`;
  return `${Math.floor(diff / 1440)} days ago`;
}

markAllAsSeen(): void {
  const url = `${SharedServiceSeenALL_Get}`;
   const userId = readSessionUserId();
  const body = { Inv_InvestorId: userId, p_UserId: Number(userId) };

 this.apiService.httpPost(url, body).subscribe({
    next: () => {
      this.unreadCount = 0;
      this.notifications = this.notifications.map(n => ({ ...n, seen: 'SEEN' }));

      console.log('All notifications marked as seen for investor:', this.investorId);
    },
    error: (err) => {
      console.error('Error marking notifications as seen:', err);
    }
  });
}

markAsSeen(notification: any): void {
  if (notification.seen === 'SEEN') return;
 const userId = readSessionUserId();
  const url = `${SharedServiceSeen_Get}`;
  const body = {
    inv_InvestorId: userId,
    notificationId: Number(notification.notificationsid),
    status: 'SEEN',
    p_UserId: Number(userId)
  };

  this.apiService.httpPost(url, body).subscribe({
    next: () => {
      notification.seen = 'SEEN';

      this.unreadCount = Math.max(0, this.unreadCount - 1);

    },
    error: (err) =>
      console.error('❌ Error marking notification as seen:', err)
  });
}

  loadUnreadCount(): void {
    this.isLoading = true;
   const url = `${SharedServiceCalling_get}`;
   const userId = readSessionUserId();
  const body = { inv_InvestorId: userId, p_UserId: Number(userId) };

    this.apiService.httpPost(url, body).subscribe({
    next: (res: any) => {
      if (res?.success) {
     this.unreadCount = res?.count ?? 0;
      }
      },
      error: (err) => {
        console.error('Error fetching unread count:', err);
        this.isLoading = false;
      }
    });
  }

getDaysAgo(dateString: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';

  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const daysAgo = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (daysAgo === 0) return 'Today';
  if (daysAgo === 1) return '1 day ago';
  return `${daysAgo} days ago`;
}

formatTime(dateString: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
}

handleClick(item: any) {


  if (item.name === 'PAYMENT_RECEIVED') {

    this.router.navigate(['/Customer/LedgerView']);
  }

  else if(item.name === 'USER_ACCESS')
  {
    this.router.navigate(['/dashboard'])
  }

   else if (item.name=== 'CAPITAL_CALL_ISSUED_INAPP')
  {
     this.router.navigate(['/Customer/Capitalcalls']);
  }
   else if(item.name === 'UNITS_ALLOCATED' || item.name ==='UNITS_REDEEMED')
  {
    this.router.navigate(['/Customer/Transaction'])
   }

   else if(item.name === 'FATCA_DOCUMENT_SIGNED' || item.name === 'FATCA_DOCUMENT_GENERATED' || item.name === 'PPM_DOCUMENT_GENERATED' || item.name
    === 'PPM_DOCUMENT_SIGNED' || item.name === 'CA_DOCUMENT_GENERATED' || item.name === 'CA_DOCUMENT_SIGNED')
   {
    this.router.navigate(['/Customer/Documents'])
   }
}

 }
  

